import { Button, Form, Select } from 'antd';
import { FormComponentProps, FormItemProps } from 'antd/lib/form';
import * as React from 'react';
import { IFreightTemplateData } from 'src/entity/SettingEntity';
import I18N from 'src/services/I18NService';
import FreightBillMethod, { IFreightBillMethodData } from './FreightBillMethod';
import FreightFreeCondition, { IFreightFreeConditionData } from './FreightFreeCondition';
import { ILocationInfo } from 'src/entity/LocationEntity';
import * as uuid from 'uuid';
import { OptionProps } from 'antd/lib/select';

interface IFreightEditProps extends FormComponentProps {
  /** 省份 */
  locations: ILocationInfo[];
  /** 需要禁用的省份 */
  disabledLocations: number[];
  /** 传入的数据 */
  freightData: IFreightTemplateData | undefined;
  /** 回调 */
  onChange(data: IFreightTemplateData): void;
}

interface IFreightEditState {
  // selectedItems: number[];
}

class FreightEdit extends React.Component<IFreightEditProps, IFreightEditState> {
  constructor(props: IFreightEditProps) {
    super(props);

    // this.state = {
    //   selectedItems: [],
    // } as IFreightEditState;
  }

  async componentDidMount() {}

  componentWillUnmount() {
    this.setState = () => {
      return;
    };
  }

  handleSubmit = (e: React.SyntheticEvent) => {
    e.preventDefault();
    this.props.form.validateFields(
      async (
        err,
        values: {
          area: number[];
          free_condition: IFreightFreeConditionData;
          normal_rule: IFreightBillMethodData;
          unusual_rule: IFreightBillMethodData;
        }
      ) => {
        if (!err) {
          const data: IFreightTemplateData = {
            rowKey: uuid.v4(),
            locations: values.area,
            enable: values.free_condition.enable,
            fee: values.free_condition.fee || 0,
            fee_start: values.normal_rule.fee || 0,
            weight_start: values.normal_rule.weight || 0,
            fee_left: values.unusual_rule.fee || 0,
            weight_left: values.unusual_rule.weight || 0,
          };
          this.props.onChange(data);
        }
      }
    );
  };

  /**
   * 检测代煎费用控件
   *
   * @memberof FreightEdit
   */
  checkFreeCondition = (rule: any, value: IFreightFreeConditionData, callback: any) => {
    try {
      if (!value.enable || (value.enable && value.fee !== undefined && value.fee >= 0)) {
        return callback();
      }
      callback(`${I18N.get('common_setting')}${I18N.get('setting_fee_template_free_condition')}`);
    } catch (err) {
      callback(err);
    }
  };

  /**
   * 检测计费方式控件
   *
   * @memberof FreightEdit
   */
  checkBillMethod = (rule: any, value: IFreightBillMethodData, callback: any) => {
    try {
      if (value.fee !== undefined && value.weight !== undefined && value.fee >= 0 && value.weight > 0) {
        return callback();
      }

      let errStr = `${I18N.get('common_setting')}`;
      if (rule.field === 'normal_rule') {
        errStr = `${errStr}${I18N.get('setting_fee_template_normal_rule')}`;
      } else if (rule.field === 'unusual_rule') {
        errStr = `${errStr}${I18N.get('setting_fee_template_unusual_rule')}`;
      }
      errStr = `${errStr}${I18N.get('setting_fee_template_bill_method')}`;
      callback(errStr);
    } catch (err) {
      callback(err);
    }
  };

  selectAllLocation = () => {
    const { locations, disabledLocations } = this.props;
    const tempList = locations.map(t => t.id).filter(ID => disabledLocations.indexOf(ID) < 0);
    this.props.form.setFieldsValue({
      area: tempList,
    });
  };

  render() {
    const { locations, freightData, disabledLocations } = this.props;
    const { getFieldDecorator } = this.props.form;
    const formItemLayout: FormItemProps = {
      labelCol: { span: 4 },
      wrapperCol: { span: 18 },
    };

    return (
      <div>
        <Form className="medicine-edit-form">
          {/* 配送地区 */}
          <Form.Item label={I18N.get('setting_fee_template_area')} {...formItemLayout}>
            {getFieldDecorator(`area`, {
              rules: [
                {
                  required: true,
                  message: `${I18N.get('common_choose')}${I18N.get('setting_fee_template_area')}`,
                },
              ],
              initialValue: !!freightData ? freightData.locations : [],
            })(
              <Select
                mode="multiple"
                allowClear={true}
                showSearch={true}
                placeholder={`${I18N.get('common_choose')}${I18N.get('setting_fee_template_area')}`}
                // value={selectedItems}
                filterOption={(inputValue: string, option: any) => option.props.children.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0}
              >
                {locations.map(p => {
                  return (
                    <Select.Option key={String(p.id)} value={p.id} disabled={disabledLocations.indexOf(p.id) > -1}>
                      {p.name}
                    </Select.Option>
                  );
                })}
              </Select>
            )}
            <a onClick={this.selectAllLocation}>{I18N.get('common_status_select_all')}</a>
          </Form.Item>
          {/* 包邮条件 */}
          <Form.Item label={I18N.get('setting_fee_template_free_condition')} {...formItemLayout}>
            {getFieldDecorator(`free_condition`, {
              rules: [{ required: true }, { validator: this.checkFreeCondition }],
              initialValue: {
                enable: !!freightData ? freightData.enable : false,
                fee: !!freightData ? freightData.fee : undefined,
              },
            })(<FreightFreeCondition key={uuid.v4()} />)}
          </Form.Item>
          {/* 计费方式 */}
          <Form.Item label={I18N.get('setting_fee_template_bill_method')} {...formItemLayout}>
            <span>&nbsp;</span>
          </Form.Item>
          {/* 计费方式-首重 */}
          <Form.Item label={I18N.get('setting_fee_template_normal_rule')} {...formItemLayout}>
            {getFieldDecorator(`normal_rule`, {
              rules: [{ required: true }, { validator: this.checkBillMethod }],
              initialValue: {
                fee: !!freightData ? freightData.fee_start : undefined,
                weight: !!freightData ? freightData.weight_start : undefined,
              },
            })(<FreightBillMethod key={uuid.v4()} />)}
          </Form.Item>
          {/* 计费方式-续重 */}
          <Form.Item label={I18N.get('setting_fee_template_unusual_rule')} {...formItemLayout}>
            {getFieldDecorator(`unusual_rule`, {
              rules: [{ required: true }, { validator: this.checkBillMethod }],
              initialValue: {
                fee: !!freightData ? freightData.fee_left : undefined,
                weight: !!freightData ? freightData.weight_left : undefined,
              },
            })(<FreightBillMethod key={uuid.v4()} />)}
          </Form.Item>
          {/* 提交 */}
          <Form.Item wrapperCol={{ span: 18, offset: 4 }}>
            <Button type="primary" onClick={this.handleSubmit}>
              {I18N.get('common_ok')}
            </Button>
          </Form.Item>
        </Form>
      </div>
    );
  }
}

const FreightEditForm = Form.create<IFreightEditProps>()(FreightEdit);
export default FreightEditForm;



// WEBPACK FOOTER //
// ./src/components/views/Setting/FreightEditForm.tsx